import React from "react";
import { AgGridReact } from "ag-grid-react";
import {useRef, useState, useCallback } from "react";
import {
  TableContainer,
  TableContent,
  TABLE_LAYOUT_OPTIONS,
  usePreventTableScrollingRef, TableHeader
} from "cdk-radial";
import classNames from "classnames";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';

export default function BundleApisGrid({ bundleApis }) {

  const EllipsisCellRenderer = ({ value }) => (
    <div className="api-dir-pkg_ellipsis-cell-renderer">{value || ""}</div>
  );

const apiNameRenderer =({data})=>{
  return <span className="api-dir-pkg_ellipsis-cell-renderer">{data?.allDetails?.name}</span>
}  
const [gridApi, setGridApi] = useState(null);
const gridRef = useRef();
const tableContentRef = usePreventTableScrollingRef();

const columns  = [
  {
    cellRendererFramework: apiNameRenderer,
    field: "api_name",
    headerName: "API Name",
    minWidth: 300,
    maxWidth: 400,
    sortable: true,
  },
  {
    cellRendererFramework: EllipsisCellRenderer,
    field: "api_type",
    headerName: "Category",
    minWidth: 200,
    maxWidth: 200,
  },
  {
    cellRendererFramework: EllipsisCellRenderer,
    field: "apiOrgName",
    headerName: "Published By",
    minWidth: 200,
    maxWidth: 200,
  },
  {
    cellRendererFramework: EllipsisCellRenderer,
    field: "summary",
    headerName: "Description",
  },
];

  const bundleApiData =
    Array.isArray(bundleApis) &&
    bundleApis?.map((api) => ({
      api_name: api?.name ? api?.name : "N/A",
      api_type:
        api?.type === "api"
          ? "REST"
          : api?.type === "async-api"
          ? "Async"
          : api?.type,
      apiOrgName: api?.orgName ? api?.orgName : "N/A",
      summary: api?.summary ? api?.summary : "N/A",
      allDetails: api,
    }));

    const handleGridReady = useCallback((gridParams) => {
      setGridApi(gridParams.api);
      gridParams.api.sizeColumnsToFit();
      gridParams.api.refreshCells({ force: true });
    }, []);

    const tableHeader=()=>{
        return <span className="api-dir-pkg_bundle-apis-count">Included APIs ({bundleApis?.length})</span>
    }

        const headerProps = {
        className: 'api-dir-pkg_bundle-apis-header',
        dataTestId: `table-header`,
        headerTitle: tableHeader(),
        hideBorder: false,
        hideTableHeader: false,
        hideTableTitle: false,
        id: `table-header`,
        isAlwaysExpanded: false,
        isSearchable: false,
        isPrintable: false,
        isDownloadable: false,
        overflowButtonProps: undefined,
    };
  return (
      <div>
     
          <TableContainer
            id="ag-grid-container"
            className={classNames(
              "api-dir-pkg_bundle-apis-table",
              "ag-theme-balham"
            )}
          >
             <TableHeader {...headerProps} />
            <TableContent
              data-testid="table-content"
              className="api-dir-pkg_bundle-apis-table"
              ref={tableContentRef}
            >
              <AgGridReact
                columnDefs={columns}
                domLayout={TABLE_LAYOUT_OPTIONS.AUTO_HEIGHT}
                rowData={bundleApiData}
                rowHeight={50}
                style={{ width: "100%" }}
                ref={gridRef}
                onGridReady={handleGridReady}
                suppressRowClickSelection={true}
                suppressScrollOnNewData={true}
              />
            </TableContent>
          </TableContainer>
      </div>
  );
};
